module.exports = __webpack_public_path__ + "img/1.734d86c5.jpg";